import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-minimal-layout',
    templateUrl: './minimal-layout.component.html',
    styleUrls: ['./minimal-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MinimalLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
